import { SignalState } from '@shared/service/signal-state-service/signal-state.service';
import { OccupiedContractPartner } from './03_current_contract_partner/model/occupied_contract_partner.model';
import { EmptyContractPartner, InvoiceAddressForm } from './03_current_contract_partner/model/empty_contract_partner.model';
import { MeterPoint } from '../../model/meter-point.model';
import {
  ContractPartnerCompanyModel,
  ContractPartnerEmptyModel,
  ContractPartnerPrivateModel,
} from './04_new_contract_partner/new-contract-partner.utils';
import { MeterPointSelection } from '../../model/product-selection.model';

export type MeterPointChangeSignalState = SignalState<MeterPointChangeState>;

export interface MeterPointChangeState {
  stepChangeType: MeterPointChangeType;
  meterPoint: MeterPoint;
  productAndDate: ProductAndDate;
  newContractPartner: NewContractPartner;
  currentContractPartner: CurrentContractPartner;
}

export interface NewContractPartner {
  emptyPartner?: ContractPartnerEmptyModel;
  formData: {
    partnerType: ContractPartnerType;
    privatePartner?: ContractPartnerPrivateModel;
    organizationPartner?: ContractPartnerCompanyModel;
  };
  alternativeInvoicingAddress: InvoiceAddressForm | null;
}

export interface CurrentContractPartner {
  occupiedContractPartner: OccupiedContractPartner | null;
  emptyContractPartner: EmptyContractPartner | null;
}

export interface ProductAndDate {
  meterPoints: MeterPointSelection[];
}

export interface MeterPointChangeDocumentResponse {
  blob: Blob;
  filename: string;
  updatedMeterPoint: MeterPoint | null;
}

export enum MeterPointChangeType {
  EMPTY_TO_OCCUPIED = 'EMPTY_TO_OCCUPIED',
  OCCUPIED_TO_EMPTY = 'OCCUPIED_TO_EMPTY',
  TENANT_CHANGE = 'TENANT_CHANGE',
}

export enum ContractPartnerType {
  PRIVATE = 'PRIVATE',
  COMPANY = 'COMPANY',
}
